import React from "react";
import Tooltip from "./reutilizables/icons";

const Contactame = ({ language }) => {
  // Traducciones en español e inglés
  const translations = {
    es: {
      title: "¡Contáctame!",
      description:
        "Puedes encontrarme en las siguientes plataformas o enviarme un correo directamente:",
      email: "julianpril1482@gmail.com",
    },
    en: {
      title: "Contact Me!",
      description:
        "You can find me on the following platforms or send me an email directly:",
      email: "julianpril1482@gmail.com",
    },
  };

  // Seleccionar traducciones según el idioma (fallback a español)
  const t = translations[language] || translations.es;

  return (
    <div className="flex flex-col items-center justify-center bg-black text-white min-h-screen p-2">
      <h2 className="text-5xl md:text-6xl font-jersey mb-8">{t.title}</h2>
      <p className="font-paragraph text-center mb-6 font-semibold">
        {t.description}{" "}
        <span className="text-cyan-500 font-semibold">{t.email}</span>
      </p>
      <div className="flex space-x-6">
        <Tooltip />
      </div>
    </div>
  );
};

export default Contactame;
